'use strict';

require('./polyfill');

var _objectFitImages = require('object-fit-images');

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

require('../sass/style.scss');

var _splitting = require('splitting');

var _splitting2 = _interopRequireDefault(_splitting);

require('./homepage/video');

require('./homepage/events-accordion');

require('./homepage/video-modal');

require('./global/anchor');

require('./slideshow/simple-slideshow');

require('./slideshow/viewer');

require('./slideshow/activity-entries');

require('./menu/main-nav');

require('./form/contact-subject');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _objectFitImages2.default)(null, { watchMQ: true });
(0, _splitting2.default)();

/** Homepage **/


/** Global **/


/** Slideshow **/


/** Menus **/


/** Form **/


//////////////////
// WEBPACK FOOTER
// ./js/main.js
// module id = ./js/main.js
// module chunks = 0